export default "__VITE_ASSET__B0AJb5Xj__"